import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Chip,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { missingDataItems } from '../../../mocks/data/itemRationalisationData';

/** Items missing allergen/nutrition/carbon data. "Flag" only updates local UI state - no
 * backend persistence exists for data-quality flags yet. */
const MissingDataTab = () => {
  const { t } = useTranslation('productManagement');
  const [flagged, setFlagged] = useState<Set<string>>(new Set());

  return (
    <Stack spacing={2}>
      <Typography variant="textSM"
        color="text.secondary">
        {t('rationalisation.missingDataIntro', 'Items missing allergen, nutrition or carbon data required for menu/offer readiness.')}
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{t('itemNumber', 'Item Number')}</TableCell>
            <TableCell>{t('description', 'Description')}</TableCell>
            <TableCell>{t('rationalisation.missingFields', 'Missing data')}</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {missingDataItems.map((item) => (
            <TableRow key={item.itemNumber}>
              <TableCell>{item.itemNumber}</TableCell>
              <TableCell>{item.description}</TableCell>
              <TableCell>
                <Stack direction="row"
                  spacing={0.5}
                  flexWrap="wrap">
                  {item.missingFields.map((field) => (
                    <Chip key={field}
                      label={field}
                      size="small"
                      color="warning"
                      variant="outlined" />
                  ))}
                </Stack>
              </TableCell>
              <TableCell>
                {flagged.has(item.itemNumber) ? (
                  <Chip label={t('rationalisation.flagged', 'Flagged for update')}
                    color="info"
                    size="small" />
                ) : (
                  <Button
                    variant="secondary"
                    size="md"
                    onClick={() => setFlagged((prev) => new Set(prev).add(item.itemNumber))}
                  >
                    {t('rationalisation.flagMissingData', 'Flag for update')}
                  </Button>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Stack>
  );
};

export default MissingDataTab;
